import styled from 'styled-components';

export const CardListContainer = styled.div``;